import type { HeaderProfileData } from '@presentation/components';

export interface PageSkeletonData {
  backLink: HeaderProfileData['backLink'];
}

export interface PageSkeletonProps extends PageSkeletonData {}
